import { Component, Output, EventEmitter, Input } from '@angular/core';
@Component({
  // tslint:disable-next-line: component-selector
  selector: 'icc-tags',
  styleUrls: ['./icc-tags.component.less'],
  template: `
    <div class="ele tag-wrapper" [attr.theme]="theme">
      <ng-content></ng-content>
      <ng-container *ngIf="!notDelete">
        <i (click)="removeHandle()" nzTooltipTitle="删除" nzTooltipPlacement="top" nz-tooltip nz-icon nzType="close" nzTheme="outline" class="close"></i>
      </ng-container>
    </div>
  `,
})
export class IccTagsComponent {
  // 主题 green | cyan | magenta | volcano | purple | blue | gray
  @Input() theme = 'cyan';
  // 是否不能删除
  @Input() notDelete = false;
  // 点击删除的回调
  @Output() removeEvent = new EventEmitter<void>();
  constructor() {}

  removeHandle() {
    this.removeEvent.next();
  }
}
